class CustomHeader {
    constructor() {
        this.mainContainer = document.querySelector(".custom-header-container");
        this.navigationContainer = document.getElementById('custom-header-navigation');
        this.navigationMenu = document.getElementById("navigation-main");

        this.menuLevelOne = document.getElementById("menu-level-one");
        this.menuLevelTwo = document.getElementById("menu-level-two");
        this.menuLevelThree = document.getElementById("menu-level-three");

        this.levelOneMenus = document.querySelectorAll("#menu-level-one .custom-list");
        this.submenuContainers = this.navigationMenu?.querySelectorAll(".submenu-container.menu-level-content");

        this.submenuTogglers = this.navigationMenu?.querySelectorAll(".reveal-menu-element");

        this.levelOneSubmenuTogglers = this.navigationMenu?.querySelectorAll("#menu-level-one .toggler-submenu");
        this.levelTwoSubmenuTogglers = this.navigationMenu?.querySelectorAll("#menu-level-two .toggler-submenu");

        this.navigationOpener = this.mainContainer?.querySelectorAll(".menu-drawer-opener");
        this.navigationCloser = this.mainContainer?.querySelectorAll(".menu-drawer-closer");

        this.animationDelay = 500;

        this.initEvents();
    }

    initEvents() {
        this.navigationOpener?.forEach(el => {
            let data_block_id = el.getAttribute("data-block");
            el.addEventListener("click", () => {
                this.handleBlockMenu(data_block_id);
                this.openCustomNavigation();
            });
        });
        this.navigationCloser?.forEach(el => {
            el.addEventListener("click", () => this.closeCustomNavigation());
        });

        this.navigationContainer?.addEventListener("click", (event) => {
            if (event.target === event.currentTarget) {
                this.closeCustomNavigation();
            }
        });

        this.submenuContainers?.forEach(el => {
            el.addEventListener("click", (event) => {
                if (event.target === event.currentTarget && !event.currentTarget.parentElement.classList.contains('open')) {
                    this.closeCustomNavigation();
                }
            });
        });

        this.submenuTogglers?.forEach(el => {
            el.addEventListener("click", () => {
                this.revealNavigationMenu(el.getAttribute("data-reveal-target"), el.getAttribute("data-reveal-handle"));
            });
        });
    }

    revealNavigationMenu(newIndentation, newMenuToOpenHandle) {
        switch (newIndentation) {
            case "one":
                /* handle indentation */
                this.navigationMenu?.classList.remove("indentation-two");
                this.navigationMenu?.classList.add("indentation-one");

                /* handle menu to open */
                if (this.menuLevelThree?.classList.contains('open')) {
                    this.closeLevelContainer("#menu-level-three");
                    setTimeout(() => {
                        this.closeLevelContainer("#menu-level-two");
                    }, this.animationDelay);
                } else {
                    this.closeLevelContainer("#menu-level-two");
                }

                /* remove focus of indentation one */
                this.removeFocus("#menu-level-one");
                break;
            case "two":
                /* handle indentation */
                this.navigationMenu?.classList.remove("indentation-one");
                this.navigationMenu?.classList.remove("indentation-three");
                this.navigationMenu?.classList.add("indentation-two");

                /* handle menu to open */
                if (this.menuLevelTwo?.classList.contains('open')) {
                    if (this.menuLevelThree?.classList.contains('open')) {
                        this.closeLevelContainer("#menu-level-three");
                        if (window.innerWidth >= 1024) {
                            setTimeout(() => {
                                var already_open = this.isMenuAlreadyOpen("#menu-level-two", "#submenu-"+newMenuToOpenHandle);
                                if (already_open) {
                                    this.removeFocus("#menu-level-one");
                                    this.closeLevelContainer("#menu-level-two");
                                } else {
                                    this.closeLevelContainer("#menu-level-two");
                                    this.openLevelContainer("#menu-level-two", "#submenu-"+newMenuToOpenHandle, newMenuToOpenHandle);
                                }
                            }, this.animationDelay);
                        } else {
                            this.removeFocus("#menu-level-two");
                        }
                    } else {
                            var already_open = this.isMenuAlreadyOpen("#menu-level-two", "#submenu-"+newMenuToOpenHandle);
                            if (already_open) {
                                this.removeFocus("#menu-level-one");
                                this.closeLevelContainer("#menu-level-two");
                            } else {
                                this.closeLevelContainer("#menu-level-two");
                                this.openLevelContainer("#menu-level-two", "#submenu-"+newMenuToOpenHandle, newMenuToOpenHandle);
                            }
                    }
                } else {
                    this.openLevelContainer("#menu-level-two", "#submenu-"+newMenuToOpenHandle, newMenuToOpenHandle);
                }
                break;
            case "three":
                /* handle indentation */
                this.navigationMenu?.classList.remove("indentation-two");
                this.navigationMenu?.classList.add("indentation-three");

                if (this.menuLevelThree?.classList.contains('open')) {
                    var already_open = this.isMenuAlreadyOpen("#menu-level-three", "#subsubmenu-"+newMenuToOpenHandle);
                    if (already_open) {
                        this.removeFocus("#menu-level-two");
                        this.closeLevelContainer("#menu-level-three");
                    } else {
                        this.closeLevelContainer("#menu-level-three");
                        setTimeout(() => {
                            this.openLevelContainer("#menu-level-three", "#subsubmenu-"+newMenuToOpenHandle, newMenuToOpenHandle);
                        }, this.animationDelay);
                    }
                } else {
                    this.openLevelContainer("#menu-level-three", "#subsubmenu-"+newMenuToOpenHandle, newMenuToOpenHandle);
                }
                break;
            default:
                break;
        }
    }

    handleBlockMenu(data_block_id) {
        this.levelOneMenus?.forEach(el => {
            if (el.getAttribute("data-block") == data_block_id) {
                el.classList.remove("hide");
            } else {
                el.classList.add("hide");
            }
        });
    }
    openCustomNavigation() {
        document.body.classList.add('overflow-hidden');
        this.navigationContainer?.classList.add('open');
    }
    closeCustomNavigation() {
        document.body.classList.remove('overflow-hidden');
        this.navigationContainer?.classList.remove('open');
        this.resetNavigationMenu();
    }
    resetNavigationMenu() {
        setTimeout(() => {
            this.navigationMenu?.classList.remove("indentation-three");
            this.navigationMenu?.classList.remove("indentation-two");
            this.navigationMenu?.classList.add("indentation-one");
            this.removeFocus("#menu-level-one");
            this.closeLevelContainer("#menu-level-two");
            this.closeLevelContainer("#menu-level-three");
        }, this.animationDelay);
    }

    isMenuAlreadyOpen(menuQuery, submenuQuery) {
        const actualSubmenu = document.querySelector(menuQuery+" .submenu-content.show");
        const paramSubmenu = document.querySelector(submenuQuery);

        if (actualSubmenu == paramSubmenu) {
            return true;
        } else {
            return false;
        }
    }

    handleSubmenus(query, action) {
        const submenus = document.querySelectorAll(query);

        switch (action) {
            case "open":
                submenus.forEach(el => {
                    el.classList.add("show");
                });
                break;
            case "close":
                submenus.forEach(el => {
                    if (window.innerWidth < 1024) {
                        setTimeout(() => {
                            el.classList.remove("show"); 
                        }, this.animationDelay);
                    } else {
                        el.classList.remove("show");
                    }
                });
                break;
        
            default:
                break;
        }
    }
    removeFocus(menu) {
        var removeHasFocus = document.querySelectorAll(`${menu} .custom-list.has-focus`);
        var removeFocus = document.querySelectorAll(`${menu} .toggler-submenu.focus`);

        removeHasFocus.forEach(el => {
            el.classList.remove("has-focus");
        });
        removeFocus.forEach(el => {
            el.classList.remove("focus");
        });
    }
    closeLevelContainer(menuQuery) {
        // if (submenuQuery) {
        //     const actualSubmenu = document.querySelector(menuQuery+" .submenu-content.show");
        //     const paramSubmenu = document.querySelector(submenuQuery);

        //     if (actualSubmenu == paramSubmenu) {
        //         console.log("already open", menuQuery);                
        //         already_open = true;
        //         return already_open;
        //     }
        // }
        document.querySelector(menuQuery).classList.remove('open');
        this.removeFocus(menuQuery);
        this.handleSubmenus(menuQuery+" .submenu-content.show", "close");
    }
    addFocus(menu, handle) {
        switch (menu) {
            case "#menu-level-one":
                break;
            case "#menu-level-two":
                var newFocus = document.querySelector(`#menu-level-one .toggler-submenu[data-reveal-handle='${handle}']`);

                this.levelOneSubmenuTogglers?.forEach(el => {
                    el.classList.remove("focus");
                });
                newFocus?.classList.add("focus");
                newFocus?.parentElement?.classList.add("has-focus");
                break;
            case "#menu-level-three":
                var newFocus = document.querySelector(`#menu-level-two .toggler-submenu[data-reveal-handle='${handle}']`);

                this.levelTwoSubmenuTogglers?.forEach(el => {
                    el.classList.remove("focus");
                });
                newFocus?.classList.add("focus");
                newFocus?.parentElement?.classList.add("has-focus");
                break;
        }
    }
    openLevelContainer (menuQuery, submenuQuery, handle) {
        document.querySelector(menuQuery).classList.add('open');
        this.handleSubmenus(submenuQuery, "open");
        this.addFocus(menuQuery, handle);
    }
}

window.addEventListener("load", function() {
    const customHeader = new CustomHeader();
});
